import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    height: "calc(100% - 60px)",
    backgroundColor: "#EBF4FD",
    borderRadius: 12,
  },
  serviceTable: {
    maxHeight: "100%",
    overflow: "auto",
  },
  serviceRow: {
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 0",
  },
  helperText: {
    marginTop: "15px !important",
    textTransform: "capitalize",
    color: "#637381",
    fontStyle: "italic",
  },
}));

export { useStyles };
